import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const MAPPING = [
  [ROUTE_NAMES.BADOOM.HOME, '/bo_merchant/dashboard'],
  [ROUTE_NAMES.BADOOM.PASSWORD_RESET, '/password_reset/?m=merchant'],
  [
    ROUTE_NAMES.BADOOM.PDF.TERMS_MERCHANT_ONBOARDING,
    '/bo_merchant/terms/merchant/onboarding',
  ],
  [
    ROUTE_NAMES.BADOOM.PDF.CERTIFICATE_TO_TRANSPORT_INVESTIGATION,
    '/seller/certificate-to-transport-investigation',
  ],
  [ROUTE_NAMES.BADOOM.DOCUSIGN_CGU, '/bo_merchant/merchant/cgu/sign'],
  [
    ROUTE_NAMES.BADOOM.LISTINGS.PRODUCT.DUPLICATE,
    '/bo_merchant/duplicate_product/:productId',
  ],
  [
    ROUTE_NAMES.BADOOM.LISTINGS.PRODUCT.CREATE,
    '/bo_merchant/listings/new/product',
  ],
]

const routes: readonly RouteRecordRaw[] = MAPPING.map(([name, path]) => ({
  name,
  path,
  component: () =>
    import('@backmarket/nuxt-layer-base/components/ExternalPagePlaceholder/ExternalPagePlaceholder.vue'),
  meta: {
    disableClientSideNavigation: () => true,
    owners: ['bot-squad-identity'],
  },
}))

export default routes
